export const RWA_SHARED_SERIES_ERC721_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "approved",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getApproved",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "uri",
        "type": "string"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_SHARED_SERIES_ERC721_BYTECODE = "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";

export const RWA_SHARED_SERIES_ERC721_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\r\npragma solidity ^1.1.2;\r\n\r\nimport \"openzeppelin-contracts/token/CRC721/CRC721.sol\";\r\nimport \"openzeppelin-contracts/token/CRC721/ICRC721Receiver.sol\";\r\nimport \"openzeppelin-contracts/utils/Address.sol\";\r\nimport \"openzeppelin-contracts/utils/Checksum.sol\";\r\n\r\n/// @dev CIP-721 CoreNFT receiver hook (canonical for Core third-party marketplaces).\r\ninterface ICBC721Receiver {\r\n    function onCBC721Received(address operator, address from, uint256 tokenId, bytes calldata data)\r\n        external\r\n        returns (bytes4);\r\n}\r\n\r\n/**\r\n * @title RwaSharedSeriesErc721\r\n * @notice CoreNFT (CBC721) catalog on OpenZeppelin Core `CRC721` (commodity-units stack): CIP-721 safe-transfer\r\n *         tries `onCBC721Received` then `ICRC721Receiver.onERC721Received`; owner + `minters` for `mint` / `burn`.\r\n */\r\ncontract RwaSharedSeriesErc721 is CRC721 {\r\n    using Address for address;\r\n\r\n    address public owner;\r\n    mapping(address => bool) public minters;\r\n    mapping(uint256 => string) private _tokenUris;\r\n\r\n    event MinterUpdated(address indexed account, bool allowed);\r\n    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);\r\n\r\n    function _isZeroLike(address account) private view returns (bool) {\r\n        return account == address(0) || account == Checksum.zeroAddress();\r\n    }\r\n\r\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) CRC721(name_, symbol_) {\r\n        owner = _msgSender();\r\n        for (uint256 i = 0; i < initialMinters.length; i++) {\r\n            address a = initialMinters[i];\r\n            if (!_isZeroLike(a)) {\r\n                minters[a] = true;\r\n                emit MinterUpdated(a, true);\r\n            }\r\n        }\r\n        emit OwnershipTransferred(address(0), owner);\r\n    }\r\n\r\n    function transferOwnership(address newOwner) external {\r\n        require(_msgSender() == owner, \"Only owner\");\r\n        require(!_isZeroLike(newOwner), \"Zero owner\");\r\n        emit OwnershipTransferred(owner, newOwner);\r\n        owner = newOwner;\r\n    }\r\n\r\n    function setMinter(address account, bool allowed) external {\r\n        require(_msgSender() == owner, \"Only owner\");\r\n        require(!_isZeroLike(account), \"Zero minter\");\r\n        minters[account] = allowed;\r\n        emit MinterUpdated(account, allowed);\r\n    }\r\n\r\n    function tokenURI(uint256 tokenId) public view virtual override returns (string memory) {\r\n        _requireMinted(tokenId);\r\n        return _tokenUris[tokenId];\r\n    }\r\n\r\n    function mint(address to, uint256 tokenId, string memory uri) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender], \"Not minter\");\r\n        require(!_isZeroLike(to), \"Zero recipient\");\r\n        require(bytes(uri).length > 0, \"Empty uri\");\r\n        _mint(to, tokenId);\r\n        _tokenUris[tokenId] = uri;\r\n    }\r\n\r\n    function burn(uint256 tokenId) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender], \"Not minter\");\r\n        delete _tokenUris[tokenId];\r\n        _burn(tokenId);\r\n    }\r\n\r\n    function _safeTransfer(address from, address to, uint256 tokenId, bytes memory data) internal virtual override {\r\n        _transfer(from, to, tokenId);\r\n        require(_checkOn721ReceivedCbcThenErc(from, to, tokenId, data), \"Receiver rejected\");\r\n    }\r\n\r\n    function _checkOn721ReceivedCbcThenErc(address from, address to, uint256 tokenId, bytes memory data)\r\n        private\r\n        returns (bool)\r\n    {\r\n        if (!to.isContract()) {\r\n            return true;\r\n        }\r\n        (bool okCbc, bytes memory retCbc) =\r\n            address(to).call(abi.encodeWithSelector(ICBC721Receiver.onCBC721Received.selector, _msgSender(), from, tokenId, data));\r\n        if (okCbc && retCbc.length >= 32 && abi.decode(retCbc, (bytes4)) == ICBC721Receiver.onCBC721Received.selector) {\r\n            return true;\r\n        }\r\n        try ICRC721Receiver(to).onERC721Received(_msgSender(), from, tokenId, data) returns (bytes4 retval) {\r\n            return retval == ICRC721Receiver.onERC721Received.selector;\r\n        } catch {\r\n            return false;\r\n        }\r\n    }\r\n}\r\n";

export const RWA_SHARED_SERIES_ERC721 = {
  contractName: "RwaSharedSeriesErc721",
  abi: RWA_SHARED_SERIES_ERC721_ABI,
  abiJson: JSON.stringify({ abi: RWA_SHARED_SERIES_ERC721_ABI, methodIdentifiers: {"approve(address,uint256)":"a613914d","balanceOf(address)":"1d7976f3","burn(uint256)":"1d5a4eb6","getApproved(uint256)":"1e964d60","isApprovedForAll(address,address)":"a333775e","mint(address,uint256,string)":"ddbd701b","minters(address)":"d6599743","name()":"07ba2a17","owner()":"be0e67a3","ownerOf(uint256)":"3753ff5b","safeTransferFrom(address,address,uint256)":"3453ba4a","safeTransferFrom(address,address,uint256,bytes)":"f3d63809","setApprovalForAll(address,bool)":"cc7a5b40","setMinter(address,bool)":"59b62736","supportsInterface(bytes4)":"80ada41b","symbol()":"231782d8","tokenURI(uint256)":"a89da637","transferFrom(address,address,uint256)":"31f2e679","transferOwnership(address)":"aae7857b"} }),
  bytecode: RWA_SHARED_SERIES_ERC721_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_SERIES_ERC721_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedSeriesErc721.sol"
};
